'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _Reflect$construct = require('@babel/runtime-corejs3/core-js-stable/reflect/construct');
var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _possibleConstructorReturn = require('@babel/runtime-corejs3/helpers/possibleConstructorReturn');
var _getPrototypeOf = require('@babel/runtime-corejs3/helpers/getPrototypeOf');
var _inherits = require('@babel/runtime-corejs3/helpers/inherits');
var _defineProperty = require('@babel/runtime-corejs3/helpers/defineProperty');
var _Object$create = require('@babel/runtime-corejs3/core-js-stable/object/create');
var _concatInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/concat');
var items_data_node = require('./items.data.node.js');
var graphchart_style = require('./graphchart.style.js');
var utils = require('./utils.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _Reflect$construct__default = /*#__PURE__*/_interopDefaultLegacy(_Reflect$construct);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _possibleConstructorReturn__default = /*#__PURE__*/_interopDefaultLegacy(_possibleConstructorReturn);
var _getPrototypeOf__default = /*#__PURE__*/_interopDefaultLegacy(_getPrototypeOf);
var _inherits__default = /*#__PURE__*/_interopDefaultLegacy(_inherits);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _Object$create__default = /*#__PURE__*/_interopDefaultLegacy(_Object$create);
var _concatInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_concatInstanceProperty);

function _callSuper(t, o, e) { return o = _getPrototypeOf__default["default"](o), _possibleConstructorReturn__default["default"](t, _isNativeReflectConstruct() ? _Reflect$construct__default["default"](o, e || [], _getPrototypeOf__default["default"](t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct__default["default"](Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * Graph chrt node object.
 * @preferred
 */
var GraphChartDataNode = /*#__PURE__*/function (_ItemsDataNode) {
  function GraphChartDataNode(internalID, exNode) {
    var _this;
    _classCallCheck__default["default"](this, GraphChartDataNode);
    _this = _callSuper(this, GraphChartDataNode, [internalID]);
    /**
     * node external id. It is mapped to internal id index. id index + type index = interal id
     * @type {string}
     */
    /**
     * node external type. It is mapped to internal type index.
     * @type {string}
     */
    /**
     * Style object for graph node object.
     */
    /**
     * Style object for graph node object.
     */
    /**
     * label object to determine which label needs to be shown in visualization.
     */
    /**
     * External x value.
     * @type {number}
     */
    /**
     * Exteranl y value.
     * @type {number}
     */
    /**
     * Layout x position
     * @type {number}
     */
    _defineProperty__default["default"](_this, "x", 0);
    /**
     * Layout y position
     * @type {number}
     */
    _defineProperty__default["default"](_this, "y", 0);
    _defineProperty__default["default"](_this, "isNode", true);
    _this.exID = exNode.id;
    _this.exType = exNode.type;
    _this.exX = exNode.x;
    _this.exY = exNode.y;
    _this.attrs = utils.Utils.cloneDeep(exNode.attrs) || _Object$create__default["default"](null);
    _this.styles = new graphchart_style.GraphStyle.GraphChartNodeStyles(exNode.styles);
    _this.others = utils.Utils.cloneDeep(exNode.others) || _Object$create__default["default"](null);
    _this.labels = utils.Utils.cloneDeep(exNode.labels) || _Object$create__default["default"](null);
    return _this;
  }

  /**
   * Merge external node. Prefer external node values.
   * @param  {ExternalNode} exNode [description]
   * @return {this}                [description]
   */
  _inherits__default["default"](GraphChartDataNode, _ItemsDataNode);
  return _createClass__default["default"](GraphChartDataNode, [{
    key: "extendNode",
    value: function extendNode(exNode) {
      var newNode = utils.Utils.cloneDeep(exNode);
      for (var key in newNode.attrs) {
        if (Object.prototype.hasOwnProperty.call(newNode.attrs, key)) {
          if (newNode.attrs[key] === '') {
            delete newNode.attrs[key];
          }
        }
      }
      utils.Utils.extend(this.attrs, newNode.attrs);
      var tmpStyle = new graphchart_style.GraphStyle.GraphChartNodeStyles(newNode.styles);
      utils.Utils.extend(this.styles, tmpStyle);
      utils.Utils.extend(this.others, newNode.others);
      utils.Utils.extend(this.labels, newNode.labels);
      return this;
    }

    /**
     * Merge external node. Prefer old node values.
     * @param  {ExternalNode} exNode [description]
     * @return {this}                [description]
     */
  }, {
    key: "defaultsNode",
    value: function defaultsNode(exNode) {
      var newNode = utils.Utils.cloneDeep(exNode);
      utils.Utils.defaultsDeep(this.attrs, newNode.attrs);
      var tmpStyle = new graphchart_style.GraphStyle.GraphChartNodeStyles(newNode.styles);
      utils.Utils.defaultsDeep(this.styles, tmpStyle);
      utils.Utils.defaultsDeep(this.others, newNode.others);
      utils.Utils.defaultsDeep(this.labels, newNode.labels);
      return this;
    }

    /**
     * Assign external node values to old nodes.
     * @param  {ExternalNode} exNode [description]
     * @return {this}                [description]
     */
  }, {
    key: "overwriteNode",
    value: function overwriteNode(exNode) {
      var newNode = utils.Utils.cloneDeep(exNode);
      this.attrs = newNode.attrs;
      var tmpStyle = new graphchart_style.GraphStyle.GraphChartNodeStyles(newNode.styles);
      this.styles = tmpStyle;
      this.others = newNode.others;
      this.labels = newNode.labels;
      return this;
    }
  }]);
}(items_data_node.ItemsDataNode);
function getNodeID(node) {
  var _context;
  return _concatInstanceProperty__default["default"](_context = "".concat(node.type, "#")).call(_context, node.id);
}
function createGraphChartDataNode(node) {
  return new GraphChartDataNode(getNodeID(node), node);
}

exports.GraphChartDataNode = GraphChartDataNode;
exports.createGraphChartDataNode = createGraphChartDataNode;
exports.getNodeID = getNodeID;
